import React, { Component } from 'react'
import { connect } from 'react-redux'
import { createEvent } from '../../containers/UserEvents/actions'
import { getAnalyticsIds } from '../OptionsHOC/helpers'
import ReactGA from 'react-ga4'

const TrackingHOC = WrappedComponent => {
  class Tracking extends Component {
    track = (category, action, label = '') => {
      let trackerNames = this.props.analyticsIds.map((id, index) => {
        return `tracker_${index}`
      })
      label = label.toString()
      ReactGA.event({ category, action, label }, trackerNames)
    }

    render() {
      const props = { ...this.props, track: this.track }
      return <WrappedComponent {...props} />
    }
  }

  const mapStateToProps = state => ({
    analyticsIds: getAnalyticsIds(state)
  })

  const mapDispatchToProps = dispatch => ({
    createEvent: event => dispatch(createEvent(event))
  })

  return connect(
    mapStateToProps,
    mapDispatchToProps
  )(Tracking)
}

export default TrackingHOC



// WEBPACK FOOTER //
// ./src/hocs/TrackingHOC/index.js